// extracted by mini-css-extract-plugin
export default {"contactInformation":"ContactInformation_contactInformation__iSx8t"};